module.exports = __webpack_public_path__ + "static/img/4.976c533d.png";